<template>
  <Notifications ref="notificationsMenu" :data="notifications" @onOpen="markUnreadNotificationsAsRead"/>
</template>

<script>
  import Notifications from "react-notifications-menu";
  import TimeAgo from 'javascript-time-ago'
  import en from 'javascript-time-ago/locale/en'

  TimeAgo.addDefaultLocale(en)

  const timeAgo = new TimeAgo('en-US')

  export default {
    name: 'NotificationsDropdown',
    mounted: function () {
    },
    computed: {
      notifications() {
        return this.$store.state.notifications.map(notification => {
          return {
            id: notification.id,
            message: notification.text,
            receivedTime: timeAgo.format(Date.parse(notification.created_at)),
            read: notification.read
          }
        })
      }
    },
    methods: {
      markUnreadNotificationsAsRead: function() {
        let ids = this.$store.state.notifications.map(n => { return n.id })
        this.$store.commit("markNotificationsAsRead", ids)
      }
    },
    components: {Notifications}
  };
</script>

